import React, { Component } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  CardHeader,
  Media,
  Input,
  Badge,
} from "reactstrap";
import {
  faAngleDown,
  faAngleUp,
  faCheck,
  faCog,
  faHome,
  faSearch,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Card,
  Table,
  Button,
  Form,
  ButtonGroup,
  Breadcrumb,
} from "@themesberg/react-bootstrap";
import {  getEmployees } from "../../../services/employeeService";
import {  getLeaves } from "../../../services/leaveService";
import SpinDiv from "../../components/SpinDiv";
import { AddLeave } from "./AddLeave";
import moment from "moment";
import { throttle,debounce } from "./debounce";
import 'antd/dist/antd.css';
import { Pagination } from 'antd';
import EditLeave from "./EditLeave";
import DeleteLeave from "./DeleteLeave";

export class LeaveIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      page: 1,
      rows: 10,
      loading: false,
      employee: JSON.parse(localStorage.getItem('user')),
      leaves:[],
      total: 0,

    

    };
    this.searchDebounced = debounce(this.searchLeaves, 500);
    this.searchThrottled = throttle(this.searchLeaves, 500);
  }

  componentDidMount() {
    this.searchLeaves();
  }

  onFilter = async (e, filter) => {
    await this.setState({ [filter]: e });
    await this.searchLeaves();
  };

  

  searchLeaves = () => {
    const { page, rows, search } = this.state;
    this.setState({ loading: false });
    getLeaves({ page, rows, search }).then(

      (res) => {
        this.setState({
          leaves: res.leaves.data,
          page: res.leaves.current_page,
          total: res.leaves.total,
          loading: false,
        });
      },
      (error) => {
        this.setState({ loading: false });
      }
    );
  };

 

  onChange = (e, state) => {
    this.setState({ [state]: e });
  };

  onPage = async (page,rows) => {
    await this.setState({page,rows});
    await this.searchLeaves();
  }
  
  handleSearch = event => {
    this.setState({ search: event.target.value }, () => {
      if(this.state.search < 5){
        this.searchThrottled(this.state.search);
      }else{
        this.searchDebounced(this.state.search);
      }
    
    });
  };
  
 

  toggleEditLeave = (leave) => {
    this.setState({ leave});
    this.searchLeaves();
   
  };
  toggleCloseLeave=(leave)=>{
    this.setState({ leave: !this.state.leave });
  }

 

  toggleCloseDelete=(deleteLeave)=>{
    this.setState({ deleteLeave: !this.state.deleteLeave });
  }

  toggleAddLeave = () => {
    this.setState({ addLeave: !this.state.addLeave });
    this.searchLeaves();
  }

  toggleAddLeaveType = () => {
    this.setState({ addLeaveType: !this.state.addLeaveType });
    this.searchLeaves();
  }

  toggleViewLeaveType = (leaveType) => {
    this.setState({ leaveType: !this.state.leaveType });
    
    this.searchLeaves();
   
  };

  toggleDeleteLeave=(deleteLeave)=>{
    this.setState({ deleteLeave });
    this.searchLeaves();
  }

  

  render() {
    const { employee, leaves,leaveType, deleteLeave, leave, total, page, rows, search, loading,addLeave, editLeave } = this.state;
    
    return (
      <>
       
        
        {addLeave && (
          <AddLeave
            saved={this.searchLeaves}
            addLeave={addLeave}
            employee={employee}
            toggle={this.toggleAddLeave}
            
          />
        )}


        {leave && (
          <EditLeave
            saved={this.searchLeaves}
            leave={leave}
            toggle={this.toggleCloseLeave}
          />
        )}

        
        {deleteLeave && (
          <DeleteLeave
            saved={this.searchLeaves}
            deleteLeave={deleteLeave}
            toggle={this.toggleCloseDelete}
          />
        )}

       
       
        {loading && <SpinDiv text={"Loading..."} />}

        <Row style={{}}>
          <Col lg="12">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
              <div className="d-block mb-4 mb-md-0">
                <Breadcrumb
                  listProps={{
                    className: " breadcrumb-text-dark text-primary",
                  }}
                >
                  <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                  <Breadcrumb.Item href="#leaves">Leaves</Breadcrumb.Item>
                </Breadcrumb>
              </div>
              <div className="btn-toolbar mb-2 mb-md-0">
                <ButtonGroup>
                  <Button variant="outline-primary" size="sm" onClick={() => this.toggleAddLeave()}>
                    Create Leave
                  </Button>
                </ButtonGroup>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="4">
            <h5 className="mb-0">Leaves 
            <span style={{color: '#aaa', fontSize: 14, fontWeight: 'normal'}}> ({total})</span></h5>
          </Col>
          
          <Col lg="4" className="">
            <div style={{ display: "flex" }}>
              <Input
                placeholder="Search..."
                autoFocus
                id="show"
                value={search}
                style={{ maxHeight: 45, marginRight: 5, marginBottom: 10 }}
                onChange={this.handleSearch}
                
              />
            </div>
          </Col>
        </Row>

        <Card border="light" className="shadow-sm mb-4">
          <Card.Body className="pb-0">
            <Table
              responsive
              className="table-centered table-nowrap rounded mb-0"
            >
              <thead className="thead-light">
                <tr>
                  <th className="border-0">Name</th>
                  <th className="border-0">Leave type</th>
                  <th className="border-0">Applied on</th>
                  <th className="border-0">Start Date</th>
                  <th className="border-0">End Date</th>
                  <th className="border-0">Total Days</th>
                  <th className="border-0">status</th>
                  <th className="border-0">Payment Type</th>
                  <th className="border-0">actions</th>
                </tr>
              </thead>
              <tbody>
                
                {leaves.map((leave, key) => {
               
                  return (
                    <tr >
                      <td>
                        <span style={{fontWeight:"bold",textTransform:"capitalize"}}>{leave.name}</span>
                        <span style={{display:"block", fontSize:10, paddingLeft:5}}>{leave.designation}</span>
                      </td>
                        
                      <td >{leave.leavetype}</td>
                      <td>{moment(leave.applied_at).format('MMM D, YYYY')}</td>
                      <td>{moment(leave.start_date).format('MMM D, YYYY')}</td>
                      <td>{moment(leave.end_date).format('MMM D, YYYY')}</td>
                      <td>{leave.total_leave_days}</td>
                      <td>
                      
                       {leave.status ==null ? <span><span style={{color:'#FFC300'}}>● </span>Pending</span> : leave.status ==1 ? <span><span style={{color:'green'}}>● </span>Approved</span> :<span><span style={{color:'red'}}>●  </span>Rejected</span>}
                      </td>
                      <td>
                      
                      {leave.payment ==null ? <span><span style={{color:'#FFC300'}}>● </span>Unpaid</span> : leave.payment ==1 ? <span><span style={{color:'green'}}>● </span>Paid</span> :<span><span style={{color:'red'}}>●  </span>Unpaid</span>}
                     </td>
                      <td>
                        
                        <ButtonGroup>
                          <Button variant="outline-primary" style={{fontWeight:"bold",textTransform:"capitalize"}} onClick={() => this.toggleEditLeave(leave)} size="sm">view</Button>
                         
                          {/* <Button variant="outline-danger" size="sm" disabled={leave.status === 1} onClick={() => this.toggleDeleteLeave(leave)}>Delete</Button> */}
                        </ButtonGroup>
                      </td>

                      
                      
                    </tr>
                  );
                })}
              </tbody>
             
            </Table>
            <Row>
              <Col md={12} style={{fontWeight:"bold",paddingTop:3}}>
              {leaves.length<1&&
                <div style={{color: '#ccc', alignSelf: 'center', padding: 10, fontSize: 13}}>
                  <i className="fa fa-ban" style={{marginRight: 5}}/>
                  No Leave Information for this employee at the moment
                </div>}
              {leaves.length > 0 && <Pagination
                  total={total}
                  showTotal={total => `Total ${total} Leaves for ${employee.name}`}
                  onChange={this.onPage}
                  pageSize={rows}
                  current={page}
                />}
              </Col>
            </Row>
          </Card.Body>
        </Card>
      </>
    );
  }
}

export default LeaveIndex;
